import {inject, NgModule} from '@angular/core';
import {Router, RouterModule, Routes} from '@angular/router';
import { NotAuthorizedComponent } from './shared/components/not-authorized/not-authorized.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { ChatComponent } from './modules/chat/chat.component';
import { AuthGuard } from './core/guards/auth.guard';
import { IncompatibleBrowserComponent } from './shared/components/incompatible-browser/incompatible-browser.component';
import { NotAvailableComponent } from './shared/components/not-available/not-available.component';
import { environment } from '../environments/environment';

const routes: Routes = [
  // Redirect legacy /my-team and anything under /my-team/* to the app root,
  // preserving the remaining sub-path and query params.
  { path: 'my-team', redirectTo: '/', pathMatch: 'full' },
  {
    path: 'my-team',
    children: [
      {
        path: '**',
        redirectTo: data =>
          inject(Router).createUrlTree(
            ['/', ...data.url.map(segment => segment.path)],
            { queryParams: data.queryParams }
          )
      }
    ]
  },
  {
		path: '',
		redirectTo: () => window.location.origin === environment.surveyUrl ? 'manage-survey' : 'my-events',
		pathMatch: 'full'
	},
	{
		path: '',
		children: [
			{
				path: '',
				loadChildren: () => import('./modules/layout/layout.module').then(m => m.LayoutModule),
				canActivate: [AuthGuard],
				data: {
					expectedRoles: [0, 1, 2]
				}
			}
		]
	},
	{
		path: '',
		component: ChatComponent,
		children: [
			{
				path: '',
				loadChildren: () => import('./modules/chat/chat.module').then(chat => chat.ChatModule)
			}
		]
	},
	{
		path: '',
		children: [
			{
				path: '',
				loadChildren: () => import('./modules/landing/landing.module').then(m => m.LandingModule)
			}
		]
	},
	{
		path: 'not-authorized',
		component: NotAuthorizedComponent
	},
	{
		path: 'not-found',
		component: NotFoundComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'incompatible-browser',
		component: IncompatibleBrowserComponent
	},
	{
		path: 'not-available',
		component: NotAvailableComponent
	},
	{
		path: '**',
		redirectTo: '/not-found'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
